<template>
    <div>
        <modal class="new-modal-default " :name="modal_name" transition="nice-modal-fade" :delay="100" :width="650"
            :height="325" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">SEND FOR APPROVAL</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="closeModal"></span>
                    </div>
                </div>
                <!-- <div class="v-modal-body" style="height:300px;">
                    <div class="v-modal-layout px-2">
                        <div class="mt-4">
                            <textarea-autosize class="bg-transparent px-2 pt-1 pb-6 mt-1 description" v-model="description"
                                placeholder="Enter Reason for Approval"
                                :min-height="100"
                                :max-height="100"
                                maxlength="1000"
                                name="reason"/>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <input type="checkbox" id="include_signature" name="vehicle1" value="Signature">
                                <label for="Signature"> Add My Signature</label>
                            </div>
                            <div>
                                <span>{{ description.length }}/1000</span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2">
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-cancel" @click="closeModal">Cancel</button>
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-save" @click="confirmApprove()">Send</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name"],
    data(){
        return {
            description: "",
        }
    },
    methods: {
        closeModal() {
            this.$emit("cancelApprove");
        },
        confirmApprove() {
            this.$emit("approveCampaigns", this.description);
        }
    }
}
</script>
<style scoped>
    .btn-new-cancel {
        color: #fff;
        background-color: #E64646;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #E64646;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .description{
        border: solid 1px #000 !important;
        border-radius: 5px!important;
        text-transform: capitalize;
        color: #000000;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/alertModals/ApproveCampaign.vue